import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import getSetCookie from '../../../../cookie';
import { bindActionCreators } from 'redux';
import sessionStorageHelper from '../../../../utils/sessionStorageHelper';
import Button from '../../../../CommonComponents/BootstrapComponents/Button/Button';
import { setCurrentReturnItem } from '../../../../actionCreators/returnExchange';
import Divider from '../../../../CommonComponents/UIComponents/Divider/Divider';
import * as productCallsActionCreators from '../../../../actionCreators/product';
import * as cartCallsActionCreators from '../../../../actionCreators/cart';
import * as commonCallsActionCreators from '../../../../actionCreators/common';
import AddPackageCoatings from '../../../components/Product/SideBar/AddPackageCoatingsModalLoadable';
import PrescriptionDetailsModal from '../../../components/Product/SideBar/PrescriptionDetailsLoadable';
import SideBarPopup from '../../../components/SideBarPopup/SideBarPopup';
import PowerTypeModalHeader from '../../../components/Product/SideBar/PowerTypeModalHeader';
import PowerTypeModal from '../../../components/Product/SideBar/PowerTypeModal';
import './OrderReturnNewSCSS/ReturnMethodDetail.scss';
import PackagesModal from '../../../components/Product/SideBar/PackagesModal';
import EyePowerSubmitInfo from '../../../components/Product/SideBar/EyePowerSubmitInfo';
import CollectionPage from '../../../../mobile/containers/CollectionPage/CollectionPage';
import Carousel from '../../../components/Carousel/Carousel';
import { ctaClickProperties } from '../../../../CommonComponents/UserPropertiesForGA/UserProperties';

const ReturnMethodDetail = props => {
  const {
    setIsExpandable,
    setFourthStep,
    setFinalStep,
    modes,
    location,
    orderDetails,
    productData,
    currentReturnItem,
    setCurrentReturnItem,
    redisCommonData,
    productCallsAction,
    cartCallsAction,
    returnEligibiliyDetails,
    getLensPackagesFailed,
    match,
    currencyMark,
    isLoader,
    setExchangeMethod,
    modifiedProductData,
    dataLocale,
    setSelectedSecondaryType,
    allModesDisabled,
    cartData,
    exchangeOrderId,
    exchangeItemId,
    LensPackage,
  } = props;
  const data = sessionStorageHelper.getItem('returnStep') || {};
  const [value, setValue] = useState(data?.exchangeMethod || '');
  const [open, setOpen] = useState(false);
  const [isWindows, setIsWindows] = useState(false);
  const [sideBar, setSideBar] = useState(false);
  const [showPackagesModal, setShowPackagesModal] = useState(false);
  const [showCoatingModal, setShowCoatingModal] = useState(false);
  const [selectedLensPackage, setSelectedLensPackage] = useState('');
  const [selectedCoating, setSelectedCoating] = useState('');
  const [collectionUrl, setCollectionUrl] = useState();
  const [addonsTotal, setaddonsTotal] = useState();
  const [ctaNameGA, setCtaNameGA] = useState('');
  const items =
    orderDetails && orderDetails?.result?.orders && orderDetails?.result?.orders[0]?.items;
  const {
    SAME_FRAME_SAME_LENS,
    SAME_FRAME_DIFFERENT_LENS,
    DIFFERENT_FRAME_DIFFERENT_LENS,
    FINAL_CONFIRMATION,
    REFUND,
    CHOOSE_FRAME_STYLE,
    CHOOSE_FROM_VARIETY_OF_FRAME_SHAPES_SHOWN_BELOW,
  } = dataLocale;

  const setSelectedPowerType = type => {
    sessionStorageHelper.setItem('selectedPowerType', type);
  };

  const [powerTab, setPowerTab] = useState({
    data: [
      { value: 'Power Type', label: 'Power Type', disabled: false },
      { value: null, label: 'Lens Type', disabled: true },
      { value: null, label: 'Add On', disabled: true },
    ],
    selectedIndex: 0,
    type: 'zero_power',
  });
  const getCarouselInfo = imageUrls => {
    const retData = {};
    retData.settings = {
      dots: true,
      slidesToShow: 1,
      arrows: false,
      pauseOnHover: true,
      adaptiveHeight: true,
    };
    retData.htmlData = imageUrls.map((url, index) => {
      return (
        <div key={`carousel-html-banner${index}`}>
          <img
            alt={`product-spec-${index}`}
            className="margin-0-auto"
            src={url}
            style={{ maxWidth: '308px' }}
          />
        </div>
      );
    });
    return retData;
  };

  let carouselInfo = null;
  if (
    productData &&
    productData.result &&
    productData.result.imageUrls &&
    productData.result.imageUrls.length
  ) {
    carouselInfo = getCarouselInfo(productData.result.imageUrls);
  }

  useEffect(() => {
    if (sideBar) {
      productCallsAction.getProductData(currentReturnItem?.item?.productId);
    }
  }, [sideBar]);

  const getUrlQueryPackage = () => {
    const query = location.search.substr(1);
    const result = {};
    query.split('&').forEach(param => {
      const item = param.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result.package;
  };

  const closePowerTypeModal = () => {
    const { LENS_TYPE, EYE_POWER_TYPE, POWER_TYPE } = props.dataLocale || {};
    setPowerTab({
      type: null,
      data: [
        { value: null, label: POWER_TYPE, disabled: false },
        { value: null, label: LENS_TYPE, disabled: true },
        { value: null, label: EYE_POWER_TYPE, disabled: true },
      ],
      selectedIndex: 0,
    });
    setSelectedLensPackage(null);
    setSelectedCoating(null);
  };

  const addToCart = (getPackage, coatings) => {
    const { classification, prices } = productData.result;
    const pkgPrice = (getPackage && getPackage.prices && getPackage.prices[1].price) || 0;
    const lenskartPrice = prices?.filter(p => p.name === 'Lenskart Price');
    let addOnsPrice = 0;
    if (coatings && coatings !== null && getPackage?.addons?.length > 0) {
      const addOnsPrices = getPackage.addons[0].prices;
      addOnsPrice = addOnsPrices[1].price;
    }
    const displayPrice = pkgPrice + lenskartPrice[0]?.price + addOnsPrice;
    const obj = {};
    const selectedPowerType = sessionStorageHelper.getItem('selectedPowerType');
    if (classification === 'eyeframe') {
      obj.powerType = selectedPowerType;
    } else if (
      classification === 'sunglasses' &&
      productData.result.prescriptionType.length > 1 &&
      getPackage !== 'normal'
    ) {
      obj.powerType = 'sunglasses';
    }
    obj.productId = productData.result.id;
    if (getPackage.id) {
      obj.packageId = getPackage.id;
      obj.addOns = coatings;
    } else {
      obj.packageId = '';
    }
    cartCallsAction.addToCart(
      {
        orderId: exchangeOrderId,
        itemId: exchangeItemId,
        productId: obj.productId,
        packageId: obj.packageId,
        addOns: obj.addOns,
        powerType: obj.powerType,
      },
      displayPrice
    );
    setShowPackagesModal(false);
    setShowCoatingModal(false);
    closePowerTypeModal();
  };

  let exchangePrice;
  const packagesConfig =
    redisCommonData?.PACKAGES_CONFIG && JSON.parse(redisCommonData.PACKAGES_CONFIG);
  const exchangeConfig =
    redisCommonData?.EXCHANGE_CONFIG && JSON.parse(redisCommonData.EXCHANGE_CONFIG);
  const exchangeFreeText = exchangeConfig && exchangeConfig?.EXCHANGE_FREE_TEXT;
  const exchangeText = exchangeConfig && exchangeConfig?.EXCHANGE_TEXT;
  const displayPrice = modifiedProductData?.firstFrameFree
    ? modifiedProductData?.firstFrameFreePrice
    : modifiedProductData?.lenskartPrice;
  if (productData) {
    exchangePrice =
      productData?.result?.prices &&
      productData?.result.prices.find(price => price.name === 'Remaining Exchange Price');
    if (exchangePrice) productCallsAction.updateExchangeRemaining(exchangePrice.price);
  }

  useEffect(() => {
    if (navigator.platform?.indexOf('Win') > -1) {
      setIsWindows(true);
    }
  }, []);

  useEffect(() => {
    const returnItemId = match?.params?.itemId;
    if (returnItemId && items && items.length && returnEligibiliyDetails) {
      const returnProductItems = items.filter(item => returnItemId == item.id); // eslint-disable-line
      const currentItemReturnEligibiliyDetails =
        returnEligibiliyDetails.items?.find(item => item.id == returnItemId) || {}; // eslint-disable-line
      setCurrentReturnItem({
        item: { ...returnProductItems[0], ...currentItemReturnEligibiliyDetails },
      });
    }
  }, [items, returnEligibiliyDetails]);

  const goToBackStep = () => {
    setShowCoatingModal(false);
    setShowPackagesModal(true);
    setSelectedCoating(null);
  };
  const addCoating = (getPackage, coatings, addonsTotal) => {
    const d = { ...powerTab };
    const selectedPowerType = sessionStorageHelper.getItem('selectedPowerType');
    if (selectedPowerType === 'zero_power') {
      addToCart(getPackage, coatings);
      closePowerTypeModal();
      return;
    }
    setPowerTab({ ...d, selectedIndex: 2 });
    setShowPackagesModal(false);
    setShowCoatingModal(false);
    setSelectedLensPackage(getPackage);
    setSelectedCoating(coatings);
    setaddonsTotal(addonsTotal);
  };
  const coatingModalClose = isCoating => {
    const d = { ...powerTab };
    const selectedPowerType = sessionStorageHelper.getItem('selectedPowerType');
    if (selectedPowerType === 'zero_power') {
      addToCart(selectedLensPackage);
      closePowerTypeModal();
      return;
    }
    setShowCoatingModal(false);
    setSelectedCoating(null);
    setPowerTab({ ...d, selectedIndex: 2 });
    setaddonsTotal(0);
    if (window.dtm.LenskartRewamp) {
      if (isCoating > 0) {
        window.dtm.LenskartRewamp.Pdp.click.addSkipCoating('coating applied|skip');
      } else {
        window.dtm.LenskartRewamp.Pdp.click.addSkipCoating('apply coating|skip');
      }
    }
  };

  const showSkipCoatingModal = getPackage => {
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.Pdp.click.addToCart(productData.result);
    if (redisCommonData && redisCommonData.SKIP_COATINGS_STEP === 'ON') {
      addToCart(getPackage);
      return;
    }
    const d = { ...powerTab };
    if (getPackage) {
      d.data[1].value = getPackage.name;
    }
    setSelectedLensPackage(getPackage);
    setPowerTab({ ...d, selectedIndex: 1 });
    if (getPackage.addons && getPackage.addons.length) {
      const selectedPowerType = sessionStorageHelper.getItem('selectedPowerType');
      const powerType = selectedPowerType.replace('_', ' ');
      const packageName = getPackage.subtitle || getPackage.name;
      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Pdp.click.addToCartLensPackage(packageName, powerType);
      setShowPackagesModal(false);
      setShowCoatingModal(true);
    } else {
      setShowPackagesModal(false);
      setShowCoatingModal(false);
      setPowerTab({ ...d, selectedIndex: 2 });
    }
  };
  const btnAddToCartWithPower = (event, type) => {
    AddPackageCoatings.preload();
    PrescriptionDetailsModal.preload();
    if (event) {
      event.preventDefault();
    }
    let frameType = null;
    let powerType = null;
    const isExpress =
      productData.result.deliveryOptions &&
      productData.result.deliveryOptions[0].deliveryOption === 'EXPRESS';
    if (productData.result.type === 'Eyeglasses') {
      productData.result.specifications.forEach(data => {
        data.items.forEach(val => {
          if (val.name === 'Frame Type') {
            frameType = val.value;
          }
        });
      });
      powerType = type.id;
      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Pdp.click.selectLenses(powerType.replace('_', ' '));
    }
    if (productData.result.type === 'Sunglasses') {
      productData.result.specifications.forEach(data => {
        data.items.forEach(val => {
          if (val.name === 'Frame Type') {
            frameType = val.value;
          }
        });
      });
      powerType = 'sunglasses';
      if (window.dtm.LenskartRewamp)
        window.dtm.LenskartRewamp.Pdp.click.selectLenses(powerType.replace('_', ' '));
    }
    if (powerType !== undefined && powerType !== 'frame_only') {
      productCallsAction.getLensPackages(
        productData.result.id,
        powerType,
        frameType,
        isExpress,
        getUrlQueryPackage()
      );
    }

    const d = { ...powerTab };
    d.type = powerType;
    d.data[1].disabled = false;
    if (type) {
      d.data[0].value = type.title;
      d.data[1].value = '';
    }
    setShowPackagesModal(true);
    setShowCoatingModal(false);
    setPowerTab({ ...powerTab, selectedIndex: 1 });
  };

  useEffect(() => {
    let input_shown = "exg";
    for (let i = 0; i< modes?.length; i++) {
      let id = modes[i].id
      let modeStatus = modes[i].error.status;
      if (id === 'SAMEPRODUCT' && !modeStatus) {
        input_shown = input_shown + "-sfsl";
      }
      if (id === 'CHANGELENS' && !modeStatus) {
        input_shown = input_shown + "-sfdl";
      }
      if (id === 'NEWPRODUCT' && !modeStatus) {
        input_shown = input_shown + "-dfdl";
      }
    }
    let obj = {
      event: 'displayed-to-users',
      input_shown:input_shown
    };
    if (typeof window.dataLayer !== 'undefined') window.dataLayer.push(obj);
    else {
      setTimeout(() => {
        window.dataLayer.push(obj);
      }, 2000);
    }

  }, []);

  const handleSelectType = id => {
    setValue(id);
    let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
    productToReturn = {
      ...productToReturn,
      returnMethod: id,
    };
    sessionStorageHelper.setItem('returnProduct', productToReturn);
    if (id === 'SAMEPRODUCT') {
      setCtaNameGA('same-frame-same-lens');
    }
    if (id === 'CHANGELENS') {
      setCtaNameGA('same-frame-different-lens');
    }
    if (id === 'NEWPRODUCT') {
      setCtaNameGA('different-frame-different-lens');
    }
  };

  const handleContinue = () => {
    let exchangeMethod = sessionStorageHelper.getItem('exchangeMethod') || {};
    let refundMethod = sessionStorageHelper.getItem('refundMethod') || {};
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    sessionStorageHelper.removeItem('returnStore');
    if (value === 'SAMEPRODUCT') {
      let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
      productToReturn = {
        ...productToReturn,
        returnProductId: currentReturnItem?.item?.id,
      };
      getSetCookie.setCookie('exchangeMethod', value, 0.25);
      sessionStorageHelper.setItem('returnProduct', productToReturn);
      cartCallsAction.addToCart({
        orderId: exchangeOrderId,
        itemId: exchangeItemId,
        exchangeMethod: value,
      });
      setIsExpandable('Shipping Address');
      exchangeMethod = value;
      returnStep = {
        ...returnStep,
        exchangeMethod: value,
        isExpandable: 'Shipping Address',
        exchangeMethodText: SAME_FRAME_SAME_LENS,
        fourthStep: true,
        finalStep: '',
        fifthStep: false,
      };
      ctaClickProperties(ctaNameGA);
      sessionStorageHelper.setItem('exchangeMethod', exchangeMethod);
      sessionStorageHelper.removeItem('refundMethod');
      setExchangeMethod(SAME_FRAME_SAME_LENS);
      setFourthStep(true);
    }
    if (value === 'CHANGELENS') {
      setExchangeMethod(SAME_FRAME_DIFFERENT_LENS);
      getSetCookie.setCookie('exchangeMethod', value, 0.25);
      returnStep = {
        ...returnStep,
        exchangeMethod: value,
        isExpandable: '',
        exchangeMethodText: SAME_FRAME_DIFFERENT_LENS,
        fourthStep: false,
        finalStep: '',
        fifthStep: false,
      };
      exchangeMethod = value;
      sessionStorageHelper.removeItem('refundMethod');
      sessionStorageHelper.setItem('exchangeMethod', exchangeMethod);
      setOpen(true);
      ctaClickProperties(ctaNameGA);
    }
    if (value === 'NEWPRODUCT') {
      exchangeMethod = value;
      getSetCookie.setCookie('exchangeMethod', value, 0.25);
      sessionStorageHelper.setItem('exchangeNP', true);
      setExchangeMethod(DIFFERENT_FRAME_DIFFERENT_LENS);
      returnStep = {
        ...returnStep,
        exchangeMethod: value,
        isExpandable: 'Shipping Address',
        exchangeMethodText: DIFFERENT_FRAME_DIFFERENT_LENS,
        fifthStep: false,
        finalStep: '',
      };
      sessionStorageHelper.removeItem('refundMethod');
      sessionStorageHelper.setItem('exchangeMethod', exchangeMethod);
      setSideBar(true);

      // For making collection url same as msite
      let brandType;
      const exchangeCatalog = props.returnConfig?.exchangeCatalog;
      let productTypeValue =
        props.currentReturnItem &&
        props.currentReturnItem.item &&
        props.currentReturnItem.item.productTypeValue;
      const brandName =
        props.currentReturnItem &&
        props.currentReturnItem.item &&
        props.currentReturnItem.item.brandName;
      if (exchangeCatalog) {
        productTypeValue = productTypeValue.toLowerCase();
        const productTypeConfig = exchangeCatalog[productTypeValue];
        if (productTypeConfig) {
          const keys = Object.keys(productTypeConfig);
          let key;
          for (let i = 0, len = keys.length; i < len; i++) {
            key = keys[i];
            if (productTypeConfig[key].includes(brandName)) {
              brandType = key;
              break;
            }
          }
        }
      }
      ctaClickProperties(ctaNameGA);
      setCollectionUrl(`exchange-${brandType}-${productTypeValue.replace(' ', '-')}`);
    }
    if (value === 'storecredit' || value === 'cashfree' || value === 'source') {
      setIsExpandable(FINAL_CONFIRMATION);
      setExchangeMethod(null);
      returnStep = {
        ...returnStep,
        exchangeMethod: '',
        isExpandable: FINAL_CONFIRMATION,
        exchangeMethodText: '',
        fourthStep: false,
        fifthStep: false,
        finalStep: REFUND,
        refundType: value,
      };
      let productToReturn = sessionStorageHelper.getItem('returnProduct') || {};
      if (cartData?.items?.length > 0) cartCallsAction.deleteCart();
      productToReturn = {
        ...productToReturn,
        refundMethod: value,
      };
      sessionStorageHelper.setItem('returnProduct', productToReturn);
      refundMethod = value;
      sessionStorageHelper.setItem('refundMethod', refundMethod);
      sessionStorageHelper.removeItem('exchangeMethod');
      setSelectedSecondaryType(value);
      setFinalStep(REFUND);
    }
    sessionStorageHelper.setItem('returnStep', returnStep);
  };
  const setPowerType = (event, type) => {
    setSelectedPowerType(type.id);
    productCallsAction.setPowerType(type.id);
    const FirstBuyPrice = productData.result?.prices?.find(key => key.name === 'First Buy Price');
    if (FirstBuyPrice) {
      btnAddToCartWithPower(event, type);
    } else if (type.id !== 'frame_only') {
      btnAddToCartWithPower(event, type);
    } else {
      addToCart(event);
      let returnStep = sessionStorageHelper.getItem('returnStep') || {};
      setIsExpandable('Shipping Address');
      returnStep = {
        ...returnStep,
        isExpandable: 'Shipping Address',
        fourthStep: true,
        finalStep: '',
        fifthStep: false,
      };
      sessionStorageHelper.setItem('returnStep', returnStep);
      setFourthStep(true);
      closePowerTypeModal();
    }
  };

  const continueEyePower = () => {
    let returnStep = sessionStorageHelper.getItem('returnStep') || {};
    addToCart(selectedLensPackage, selectedCoating);
    setIsExpandable('Shipping Address');
    returnStep = {
      ...returnStep,
      isExpandable: 'Shipping Address',
      fourthStep: true,
      finalStep: '',
      fifthStep: false,
    };
    sessionStorageHelper.setItem('returnStep', returnStep);
    setFourthStep(true);
    setOpen(false);
  };
  const changeLensPackageTab = index => {
    setShowPackagesModal(true);
    setShowCoatingModal(false);
    setSelectedLensPackage(index === 0 ? null : selectedLensPackage);
    setSelectedCoating(index === 0 || index === 1 ? null : selectedCoating);
    setPowerTab({ ...powerTab, selectedIndex: index });
  };

  const lensPackageModalClose = () => {
    setShowPackagesModal(false);
    const selectedPowerType = sessionStorageHelper.getItem('selectedPowerType');
    const powerType = selectedPowerType;
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.Pdp.click.lensPackageClose(powerType.replace('_', ' '));
  };

  const renderContinueBtn = id => {
    let buttonText = '';
    if (value === id) {
      if (value === 'CHANGELENS') buttonText = 'Choose lens';
      else if (value === 'NEWPRODUCT') buttonText = 'Choose frame & lens';
      else buttonText = 'Continue';
      return (
        <div>
          <Button
            className="margin-r10 text-color-white bg-color-primary no-decoration flex-basis-20 text-center block bora-4 fw700 text-uppercase"
            style={{ width: '200px' }}
            onClick={handleContinue}
          >
            {buttonText}
          </Button>
        </div>
      );
    }
  };
  if (!sideBar) sessionStorageHelper.removeItem('exchangeNP');
  const { selectedIndex } = powerTab;
  const selectedPowerTypeStored = sessionStorageHelper.getItem('selectedPowerType');
  return (
    <div>
      <div className="sub-option">
        {
          <div>
            {modes &&
              modes.map((mode, i) => {
                return (
                  <div
                    className={`display-flex align-items-center ${
                      i === modes.length ? '' : 'border-bottom'
                    } margin-b10`}
                  >
                    <label
                      className="display-flex"
                      htmlFor={mode.id}
                      style={{ width: '65%' }}
                      title={mode.id}
                    >
                      <div className="margin-r20 display-flex align-items-center">
                        {!mode.error.status ? (
                          <input
                            checked={value === mode.id}
                            type="radio"
                            value={mode.id}
                            onChange={() => handleSelectType(mode.id)}
                          />
                        ) : (
                          <input disabled type="radio" />
                        )}
                      </div>
                      <div className="success display-flex">
                        <img
                          alt={mode.alt}
                          className={`refund-img ${mode.error.status ? 'filter' : ''} ${
                            mode.error.status ? '' : 'cursor-pointer'
                          }`}
                          src={mode.src}
                          onClick={mode.error.status ? '' : () => handleSelectType(mode.id)}
                        />
                        <div
                          className={`${mode.error.status ? '' : 'cursor-pointer'}`}
                          onClick={mode.error.status ? '' : () => handleSelectType(mode.id)}
                        >
                          <div className="display-flex">
                            <span
                              className={`roboto ${
                                mode.error.status ? 'text-color-grey' : ''
                              } fw500 fsp14 lh-16 text-color_dark_grey`}
                            >
                              {mode.title}
                            </span>
                            <div className="badge-container">
                              {Boolean(mode.badge) && (
                                <span className="return-badge text-color_red fsp12 lh-11 ine-height-20 bora-2">
                                  {mode.badge}
                                </span>
                              )}
                            </div>
                          </div>
                          <div>
                            {mode.subText.contents && !mode.error.status && (
                              <p className="fs12 roboto text-color-grey fw500">
                                {mode.subText.contents[0]}
                                <br />
                                {mode.subText.contents[1] && mode.subText.contents[1]}
                              </p>
                            )}
                            {!allModesDisabled && mode.error && (
                              <div className="error" data-testid="errorMode">
                                {mode.error.status && (
                                  <div className="display-flex align-items-center mr-t8">
                                    <span
                                      className="fsp11 mr-l8 lh-14 roboto text-red"
                                      dangerouslySetInnerHTML={{ __html: mode.error.text }}
                                    ></span>
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="display-flex flex-direction-column mr-l15"></div>
                      </div>
                    </label>
                    <div style={{ width: '35%' }}>
                      {!mode.error.status && renderContinueBtn(mode.id)}
                    </div>
                  </div>
                );
              })}
            {/* Same Frame Different Lens */}
            {open && (
              <SideBarPopup
                dialogClassName="power-type-modal"
                open={open}
                width="100vw"
                onClose={setOpen}
              >
                {carouselInfo && (
                  <div
                    className={`product-img-carousel inline-block${isWindows ? ' window-os' : ''}`}
                  >
                    <div className="display-flex align-items-center" style={{ height: '100%' }}>
                      <Carousel
                        carouselConfig={carouselInfo.settings}
                        carouselHtmlData={carouselInfo.htmlData}
                      ></Carousel>
                    </div>
                  </div>
                )}
                <div className="product-pkg-selection inline-block">
                  <PowerTypeModalHeader
                    changeTab={index => changeLensPackageTab(index)}
                    frameColour={currentReturnItem?.item?.frameColour}
                    frameShape={currentReturnItem?.item?.frameShape}
                    frameType={currentReturnItem?.item?.frameType}
                    selectedPowerType={selectedPowerTypeStored}
                    tabData={powerTab}
                    type={currentReturnItem?.productTypeValue}
                  />
                  {selectedIndex === 0 && (
                    <PowerTypeModal
                      dataLocale={dataLocale}
                      frameShape={currentReturnItem?.frameShape}
                      frameType={currentReturnItem?.frameType}
                      productData={productData.result}
                      redisCommonData={redisCommonData}
                      selectedPowerTypeTab={selectedPowerTypeStored}
                      setPowerType={setPowerType}
                      setSelectedPowerType={setSelectedPowerType}
                    />
                  )}
                  {selectedIndex === 1 && showCoatingModal && !showPackagesModal && (
                    <AddPackageCoatings
                      addCoatings={(coatings, addonsTotal) => {
                        addCoating(selectedLensPackage, coatings, addonsTotal);
                      }}
                      coatingModalClose={coatingModalClose}
                      dataLocale={dataLocale}
                      goToBackStep={() => {
                        goToBackStep();
                      }}
                      productData={productData.result}
                      selectedLensPackage={selectedLensPackage}
                      showCoatingModal={showCoatingModal}
                    />
                  )}
                  {selectedIndex === 1 && showPackagesModal && !showCoatingModal && (
                    <PackagesModal
                      isExchange
                      isExchangeFlow
                      LensPackage={LensPackage}
                      addToCart={showSkipCoatingModal}
                      currencyMark={currencyMark}
                      dataLocale={dataLocale}
                      displayPrice={displayPrice}
                      exchangeBalance={exchangePrice}
                      exchangeFreeText={exchangeFreeText}
                      exchangeText={exchangeText}
                      getLensPackagesFailed={getLensPackagesFailed}
                      isLoader={isLoader}
                      lensPackageModalClose={lensPackageModalClose}
                      packagesConfig={packagesConfig}
                      productData={productData.result}
                      redisCommonData={redisCommonData}
                      showPackagesModal={showPackagesModal}
                    />
                  )}
                  {selectedIndex === 2 && (
                    <EyePowerSubmitInfo
                      addonsTotal={addonsTotal}
                      continueEyePower={() => continueEyePower()}
                      currencyMark={currencyMark}
                      dataLocale={dataLocale}
                      productData={productData.result}
                      selectedCoating={selectedCoating}
                      selectedIndex={selectedIndex}
                      selectedLensPackage={selectedLensPackage}
                    ></EyePowerSubmitInfo>
                  )}
                </div>
              </SideBarPopup>
            )}
            {/* Different Frame Different Lens */}
            {sideBar && (
              <SideBarPopup
                dialogClassName="power-type-modal"
                open={sideBar}
                width={collectionUrl ? '35vw' : '65vw'}
                onClose={setSideBar}
              >
                {/* Header */}
                <div className="margin-t16 margin-b16 margin-l24">
                  <div className="fs20 fw500 text-capitalize">{CHOOSE_FRAME_STYLE}</div>
                  <div className="fs14" style={{ color: 'rgba(60, 60, 60, 0.54)' }}>
                    {CHOOSE_FROM_VARIETY_OF_FRAME_SHAPES_SHOWN_BELOW}
                  </div>
                </div>
                <div className={`${collectionUrl ? '' : ''}`}>
                  <Divider />
                </div>
                {/* Collection Page */}
                {collectionUrl && (
                  <CollectionPage
                    isDesktopExchange
                    collectionUrl={collectionUrl}
                    location={location}
                  />
                )}
              </SideBarPopup>
            )}
          </div>
        }
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  const cartData = state.cart.cartData ? state.cart.cartData.result : null;
  return {
    returnConfig: state.myAccount.returnConfig,
    cartData,
    dataLocale: state.locale,
    currentReturnItem: state.returnExchange.currentReturnItem,
    productData: state.product.productData,
    getLensPackagesFailed: state.product.getLensPackagesFailed,
    LensPackage: state.product.getLensPackages,
    exchangeOrderId: state.returnExchange.exchangeOrderId,
    exchangeItemId: state.returnExchange.exchangeItemId,
    orderDetails: state.order.orderDetails,
    currencyMark: state.common.currencyMark,
    addToCartSuccess: state.cart.addToCartSuccess,
    returnEligibiliyDetails: state.returnExchange.returnEligibiliyDetails,
    returnEligibiliyDetailsLoading: state.returnExchange.returnEligibiliyDetailsLoading,
    addToCartFailed: state.cart.addToCartFailed,
    modifiedProductData: state.product.modifiedProductData,
    isLoader: state.product.loadingPackage,
  };
};
function mapDispatchToProps(dispatch) {
  return {
    productCallsAction: bindActionCreators(productCallsActionCreators, dispatch),
    cartCallsAction: bindActionCreators(cartCallsActionCreators, dispatch),
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
    setCurrentReturnItem: data => dispatch(setCurrentReturnItem(data)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(ReturnMethodDetail);
